import * as _utils from './_utils';
import { ui } from './modules/ui';
import { a11y } from './modules/a11y';
import { mobileHandler } from './modules/mobile';
import { formsHandler } from './modules/forms';
import { sharersHandler } from './modules/sharers';
import { messagesHandler } from './modules/messages';

document.addEventListener('DOMContentLoaded', function (event) {
    mobileHandler.init();
    formsHandler.init();
    a11y.init();
    ui.init();
    messagesHandler.init();
    sharersHandler.init();
});